<template>
	<div>
		<final-report-header-row
			text="3. Zestawienie dokumentów"
		/>
		<v-layout class="final-report-invoices-header">
			<v-flex xs1 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Lp.
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs2 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Rodzaj dokumentu
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs2 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Numer dokumentu
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Wartość całkowita dokumentu <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs2 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Data wystawienia
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs2 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>
							Data zapłaty
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs2 d-flex>
				<v-card color='grey darken-1'>
					<v-card-text style="text-align: center">
						<strong>

						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-layout class="final-report-invoices-header">
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text>
						<strong>

						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							Numer pozycji
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs5 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							Nazwa kosztu
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							z dotacji <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							z innych środków finansowych <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							z uzyskanych odsetek od dotacji
							lub pozostałych przychodów <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							wkład rzeczowy <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
			<v-flex xs1 d-flex>
				<v-card color='grey darken-0'>
					<v-card-text style="text-align: center">
						<strong>
							wkład osobowy <br> (w zł)
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<v-layout>
			<v-flex xs12 d-flex>
				<v-card color='grey darken-2'>
					<v-card-text>
						<strong>
							A. Koszty administracyjne
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<div v-for="(invoice, index) in administrativeCostsInvoices" :key="'administrative-' + index">
			<template
				v-if="invoiceChanged(invoice) && invoiceAdministrativeDataChanged(invoice.data.old, invoice.data.new)">
				<final-report-invoices-invoice-general-data-row-comparison
					v-if="invoice.data.old.administrative.length > 0"
					:index="index"
					:invoice="invoice.data.old"
					:invoice-type="invoice.data.new.administrative.length > 0 ? changedOldVersionComparisonValue : removedComparisonValue"
				/>
				<final-report-invoices-single-cost-comparison
					v-for="(cost, costIndex) in invoice.data.old.administrative"
					:key="'administrative-cost_1-' + costIndex"
					:cost="cost"
					:invoice-type="invoice.data.new.administrative.length > 0 ? changedOldVersionComparisonValue : removedComparisonValue"
				/>
				<final-report-invoices-invoice-general-data-row-comparison
					v-if="invoice.data.new.administrative.length > 0"
					:index="index"
					:invoice="invoice.data.new"
					:invoice-type="invoice.data.old.administrative.length > 0 ? changedNewVersionComparisonValue : addedComparisonValue"
				/>
				<final-report-invoices-single-cost-comparison
					v-for="(cost, costIndex) in invoice.data.new.administrative"
					:key="'administrative-cost_2-' + costIndex"
					:cost="cost"
					:invoice-type="invoice.data.old.administrative.length > 0 ? changedNewVersionComparisonValue : addedComparisonValue"
				/>
			</template>
			<template v-else-if="!invoiceChanged(invoice)">
				<final-report-invoices-invoice-general-data-row-comparison
					:index="index"
					:invoice="invoice.data"
					:invoice-type="invoice.type"
				/>
				<final-report-invoices-single-cost-comparison
					v-for="(cost, costIndex) in invoice.data.administrative"
					:key="'administrative-cost_3-' + costIndex"
					:cost="cost"
					:invoice-type="invoice.type"
				/>
			</template>
			<template v-else>
				<final-report-invoices-invoice-general-data-row-comparison
					:index="index"
					:invoice="invoice.data.new"
					:invoice-type="sameComparisonValue"
				/>
				<final-report-invoices-single-cost-comparison
					v-for="(cost, costIndex) in invoice.data.new.administrative"
					:key="'administrative-cost_3-' + costIndex"
					:cost="cost"
					:invoice-type="sameComparisonValue"
				/>
			</template>
		</div>

		<template>
			<v-layout>
				<v-flex xs7 d-flex>
					<v-card :color='administrativeSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text>
							<strong>
								{{administrativeSummaryDiffers ? 'Razem A (Było)' : 'Razem A'}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='administrativeSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{administrativeSummary.old.donation}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='administrativeSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{administrativeSummary.old.otherSources}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='administrativeSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{administrativeSummary.old.interests}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='administrativeSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{administrativeSummary.old.ownInKind}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='administrativeSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{administrativeSummary.old.ownHuman}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</template>

		<template v-if="administrativeSummaryDiffers">
			<v-layout>
				<v-flex xs7 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text>
							<strong>
								Razem A (Jest)
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{administrativeSummary.new.donation}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{administrativeSummary.new.otherSources}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{administrativeSummary.new.interests}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{administrativeSummary.new.ownInKind}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{administrativeSummary.new.ownHuman}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</template>

		<v-layout>
			<v-flex xs12 d-flex>
				<v-card color='grey darken-2'>
					<v-card-text>
						<strong>
							P. Koszty programowe
						</strong>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

		<div v-for="(invoice, index) in actionsCostsInvoices" :key="'actions-' + index">
			<template v-if="invoiceChanged(invoice) && invoiceActionsDataChanged(invoice.data.old, invoice.data.new)">
				<final-report-invoices-invoice-general-data-row-comparison
					v-if="invoice.data.old.actions.length > 0"
					:index="index"
					:invoice="invoice.data.old"
					:invoice-type="invoice.data.new.actions.length > 0 ? changedOldVersionComparisonValue : removedComparisonValue"
				/>
				<div
					v-for="action in invoice.data.old.actions"
					:key="'serial-number_1-' + action.serialNumber"
				>
					<final-report-invoices-single-cost-comparison
						v-for="(cost, costIndex) in action.costs"
						:key="'actions-cost_1-' + costIndex"
						:lp-prefix="action.serialNumber"
						:cost="cost"
						:invoice-type="invoice.data.new.actions.length > 0 ? changedOldVersionComparisonValue : removedComparisonValue"
					/>
				</div>
				<final-report-invoices-invoice-general-data-row-comparison
					v-if="invoice.data.new.actions.length > 0"
					:index="index"
					:invoice="invoice.data.new"
					:invoice-type="invoice.data.old.actions.length > 0 ? changedNewVersionComparisonValue : addedComparisonValue"
				/>
				<div
					v-for="action in invoice.data.new.actions"
					:key="'serial-number_2-' + action.serialNumber"
				>
					<final-report-invoices-single-cost-comparison
						v-for="(cost, costIndex) in action.costs"
						:key="'actions-cost_2-' + costIndex"
						:lp-prefix="action.serialNumber"
						:cost="cost"
						:invoice-type="invoice.data.old.actions.length > 0 ? changedNewVersionComparisonValue : addedComparisonValue"
					/>
				</div>
			</template>
			<template v-else-if="!invoiceChanged(invoice)">
				<final-report-invoices-invoice-general-data-row-comparison
					:index="index"
					:invoice="invoice.data"
					:invoice-type="invoice.type"
				/>
				<div
					v-for="action in invoice.data.actions"
					:key="'serial-number_3-' + action.serialNumber"
				>
					<final-report-invoices-single-cost-comparison
						v-for="(cost, costIndex) in action.costs"
						:key="'actions-cost_3-' + costIndex"
						:lp-prefix="action.serialNumber"
						:cost="cost"
						:invoice-type="invoice.type"
					/>
				</div>
			</template>
			<template v-else>
				<final-report-invoices-invoice-general-data-row-comparison
					:index="index"
					:invoice="invoice.data.new"
					:invoice-type="sameComparisonValue"
				/>
				<div
					v-for="action in invoice.data.new.actions"
					:key="'serial-number_3-' + action.serialNumber"
				>
					<final-report-invoices-single-cost-comparison
						v-for="(cost, costIndex) in action.costs"
						:key="'actions-cost_3-' + costIndex"
						:lp-prefix="action.serialNumber"
						:cost="cost"
						:invoice-type="sameComparisonValue"
					/>
				</div>
			</template>
		</div>

		<template>
			<v-layout>
				<v-flex xs7 d-flex>
					<v-card :color='actionsSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text>
							<strong>
								{{actionsSummaryDiffers ? 'Razem P (Było)' : 'Razem P'}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='actionsSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{actionsSummary.old.donation}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='actionsSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{actionsSummary.old.otherSources}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='actionsSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{actionsSummary.old.interests}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='actionsSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{actionsSummary.old.ownInKind}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='actionsSummaryDiffers ? "blue lighten-4" : "grey"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{actionsSummary.old.ownHuman}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</template>

		<template v-if="actionsSummaryDiffers">
			<v-layout>
				<v-flex xs7 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text>
							<strong>
								Razem P (Jest)
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{actionsSummary.new.donation}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{actionsSummary.new.otherSources}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{actionsSummary.new.interests}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{actionsSummary.new.ownInKind}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-4'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{actionsSummary.new.ownHuman}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</template>

		<template>
			<v-layout>
				<v-flex xs7 d-flex>
					<v-card :color='wholeSummaryDiffers ? "blue lighten-5" : "grey darken-1"'>
						<v-card-text>
							<strong>
								{{wholeSummaryDiffers ? 'Ogółem (Było)' : 'Ogółem'}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='wholeSummaryDiffers ? "blue lighten-5" : "grey darken-1"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{wholeSummary.old.donation}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='wholeSummaryDiffers ? "blue lighten-5" : "grey darken-1"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{wholeSummary.old.otherSources}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='wholeSummaryDiffers ? "blue lighten-5" : "grey darken-1"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{wholeSummary.old.interests}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='wholeSummaryDiffers ? "blue lighten-5" : "grey darken-1"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{wholeSummary.old.ownInKind}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card :color='wholeSummaryDiffers ? "blue lighten-5" : "grey darken-1"'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{wholeSummary.old.ownHuman}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</template>

		<template v-if="wholeSummaryDiffers">
			<v-layout>
				<v-flex xs7 d-flex>
					<v-card color='blue lighten-5'>
						<v-card-text>
							<strong>
								Ogółem (Jest)
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-5'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{wholeSummary.new.donation}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-5'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{wholeSummary.new.otherSources}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-5'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{wholeSummary.new.interests}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-5'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{wholeSummary.new.ownInKind}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
				<v-flex xs1 d-flex>
					<v-card color='blue lighten-5'>
						<v-card-text style="padding-left: 0; padding-right: 5px; text-align: right">
							<strong>
								{{wholeSummary.new.ownHuman}}
							</strong>
						</v-card-text>
					</v-card>
				</v-flex>
			</v-layout>
		</template>
	</div>
</template>

<script>
	import FinalReportHeaderRow from "./FinalReportHeaderRow";
	import FinalReportInvoicesInvoiceGeneralDataRowComparison from "./FinalReportInvoicesGeneralDataRowComparison";
	import FinalReportInvoicesSingleCostComparison from "./FinalReportInvoicesSingleCostComparison";
	import {Numbers} from "@/utils/Numbers";
	import {InvoiceComparisonResult} from "./Utils/InvoiceComparisonResult";

	export default {
		name: "FinalReportInvoicesComparison",
		components: {
			FinalReportInvoicesSingleCostComparison,
			FinalReportInvoicesInvoiceGeneralDataRowComparison, FinalReportHeaderRow
		},

		mixins: [
			Numbers
		],

		data () {
			return {
				processedInvoices: [],
				administrativeCostsInvoices: [],
				actionsCostsInvoices: [],
				administrativeSummary: {
					old: {
						donation: undefined,
						otherSources: undefined,
						interests: undefined,
						ownInKind: undefined,
						ownHuman: undefined
					},
					new: {
						donation: undefined,
						otherSources: undefined,
						interests: undefined,
						ownInKind: undefined,
						ownHuman: undefined
					}
				},
				actionsSummary: {
					old: {
						donation: undefined,
						otherSources: undefined,
						interests: undefined,
						ownInKind: undefined,
						ownHuman: undefined
					},
					new: {
						donation: undefined,
						otherSources: undefined,
						interests: undefined,
						ownInKind: undefined,
						ownHuman: undefined
					}
				},
				wholeSummary: {
					old: {
						donation: undefined,
						otherSources: undefined,
						interests: undefined,
						ownInKind: undefined,
						ownHuman: undefined
					},
					new: {
						donation: undefined,
						otherSources: undefined,
						interests: undefined,
						ownInKind: undefined,
						ownHuman: undefined
					}
				}
			};
		},

		mounted () {
			this.processInvoices();
      for (let invoice in this.administrativeCostsInvoices) {
        if (this.invoiceChanged(invoice) || (invoice.data
            && this.invoiceAdministrativeDataChanged(invoice.data.old, invoice.data.new))) {
          this.$emit('dataDiffer');
        }
      }
      for (let invoice in this.actionsCostsInvoices) {
        if (this.invoiceChanged(invoice) || (invoice.data
            && this.invoiceActionsDataChanged(invoice.data.old, invoice.data.new))) {
          this.$emit('dataDiffer');
        }
      }
		},

		computed: {
			changedOldVersionComparisonValue () {
				return InvoiceComparisonResult.changedOldVersion;
			},

			changedNewVersionComparisonValue () {
				return InvoiceComparisonResult.changedNewVersion;
			},

			removedComparisonValue () {
				return InvoiceComparisonResult.removed;
			},

			addedComparisonValue () {
				return InvoiceComparisonResult.added;
			},

			sameComparisonValue () {
				return InvoiceComparisonResult.same;
			},

			administrativeSummaryDiffers () {
				let difference = false;
				for (let key of Object.keys(this.administrativeSummary.old)) {
					if (this.administrativeSummary.old[key] !== this.administrativeSummary.new[key]) {
						difference = true;
						break;
					}
				}
				return difference;
			},

			actionsSummaryDiffers () {
				let difference = false;
				for (let key of Object.keys(this.actionsSummary.old)) {
					if (this.actionsSummary.old[key] !== this.actionsSummary.new[key]) {
						difference = true;
						break;
					}
				}
				return difference;
			},

			wholeSummaryDiffers () {
				return this.administrativeSummaryDiffers || this.actionsSummaryDiffers;
			}
		},

		methods: {
			invoiceChanged (invoice) {
				return invoice.type === InvoiceComparisonResult.changed;
			},

			processInvoices () {
				this.currentInvoices.forEach(current => {
					let prevInvoiceVersion = this.oldInvoices.find(old => old.originalDocumentId === current.originalDocumentId);
					if (!prevInvoiceVersion) this.processedInvoices.push({
						data: current,
						type: InvoiceComparisonResult.added
					});
					else {
						if (this.getInvoiceComparisonResult(prevInvoiceVersion, current) === InvoiceComparisonResult.changed) {
							this.processedInvoices.push({
								data: {
									new: current,
									old: prevInvoiceVersion
								}, type: InvoiceComparisonResult.changed
							});
						} else {
							this.processedInvoices.push({data: current, type: InvoiceComparisonResult.same});
						}
					}
				});
				let currVersionDocumentIds = this.currentInvoices.map(item => item.originalDocumentId);
				this.oldInvoices.filter(old => !currVersionDocumentIds.includes(old.originalDocumentId)).forEach(item => {
					this.processedInvoices.push({data: item, type: InvoiceComparisonResult.removed});
				});
				let getDocumentId = (item) => {
					return item.type === InvoiceComparisonResult.other ? item.data.new.originalDocumentId : item.data.originalDocumentId;
				};
				this.processedInvoices.sort((item1, item2) => {
					return getDocumentId(item1) - getDocumentId(item2);
				});

				let adminCostsInvoices = this.processedInvoices.filter(invoice => invoice.type === InvoiceComparisonResult.changed ?
					invoice.data.new.administrative.length > 0 || invoice.data.old.administrative.length > 0 :
					invoice.data.administrative.length > 0);
				let actCostsInvoices = this.processedInvoices.filter(invoice => invoice.type === InvoiceComparisonResult.changed ?
					invoice.data.new.actions.length > 0 || invoice.data.old.actions.length > 0 :
					invoice.data.actions.length > 0);
				this.$set(this, 'administrativeCostsInvoices', adminCostsInvoices);
				this.$set(this, 'actionsCostsInvoices', actCostsInvoices);
				this.administrativeSummary = this.prepareAdministrativeSummary();
				this.actionsSummary = this.prepareActionsSummary();
				this.wholeSummary = this.prepareWholeSummary();
			},

			prepareAdministrativeSummary () {
				return {
					old: {
						donation: this.formatMoney(this.costOfTypeAdministrativeCostsInvoices(['z dotacji'], false)),
						otherSources: this.formatMoney(this.costOfTypeAdministrativeCostsInvoices([
							'środki finansowe własne',
							'świadczenie pieniężne od odbiorców',
							'środki finansowe z innych źródeł publicznych',
							'pozostałe'], false)),
						interests: this.formatMoney(this.costOfTypeAdministrativeCostsInvoices(['odsetki', 'przychody'], false)),
						ownInKind: this.formatMoney(this.costOfTypeAdministrativeCostsInvoices(['wkład rzeczowy'], false)),
						ownHuman: this.formatMoney(this.costOfTypeAdministrativeCostsInvoices(['wkład osobowy'], false))
					},
					new: {
						donation: this.formatMoney(this.costOfTypeAdministrativeCostsInvoices(['z dotacji'], true)),
						otherSources: this.formatMoney(this.costOfTypeAdministrativeCostsInvoices([
							'środki finansowe własne',
							'świadczenie pieniężne od odbiorców',
							'środki finansowe z innych źródeł publicznych',
							'pozostałe'], true)),
						interests: this.formatMoney(this.costOfTypeAdministrativeCostsInvoices(['odsetki', 'przychody'], true)),
						ownInKind: this.formatMoney(this.costOfTypeAdministrativeCostsInvoices(['wkład rzeczowy'], true)),
						ownHuman: this.formatMoney(this.costOfTypeAdministrativeCostsInvoices(['wkład osobowy'], true))
					}
				};
			},

			prepareActionsSummary () {
				return {
					old: {
						donation: this.formatMoney(this.costOfTypeActionsCostsInvoices(['z dotacji'], false)),
						otherSources: this.formatMoney(this.costOfTypeActionsCostsInvoices([
							'środki finansowe własne',
							'świadczenie pieniężne od odbiorców',
							'środki finansowe z innych źródeł publicznych',
							'pozostałe'], false)),
						interests: this.formatMoney(this.costOfTypeActionsCostsInvoices(['odsetki', 'przychody'], false)),
						ownInKind: this.formatMoney(this.costOfTypeActionsCostsInvoices(['wkład rzeczowy'], false)),
						ownHuman: this.formatMoney(this.costOfTypeActionsCostsInvoices(['wkład osobowy'], false))
					},
					new: {
						donation: this.formatMoney(this.costOfTypeActionsCostsInvoices(['z dotacji'], true)),
						otherSources: this.formatMoney(this.costOfTypeActionsCostsInvoices([
							'środki finansowe własne',
							'świadczenie pieniężne od odbiorców',
							'środki finansowe z innych źródeł publicznych',
							'pozostałe'], true)),
						interests: this.formatMoney(this.costOfTypeActionsCostsInvoices(['odsetki', 'przychody'], true)),
						ownInKind: this.formatMoney(this.costOfTypeActionsCostsInvoices(['wkład rzeczowy'], true)),
						ownHuman: this.formatMoney(this.costOfTypeActionsCostsInvoices(['wkład osobowy'], true))
					}
				};
			},

			prepareWholeSummary () {
				return {
					old: {
						donation: this.formatMoney(this.costOfTypeAllCostsInvoices(['z dotacji'], false)),
						otherSources: this.formatMoney(this.costOfTypeAllCostsInvoices([
							'środki finansowe własne',
							'świadczenie pieniężne od odbiorców',
							'środki finansowe z innych źródeł publicznych',
							'pozostałe'], false)),
						interests: this.formatMoney(this.costOfTypeAllCostsInvoices(['odsetki', 'przychody'], false)),
						ownInKind: this.formatMoney(this.costOfTypeAllCostsInvoices(['wkład rzeczowy'], false)),
						ownHuman: this.formatMoney(this.costOfTypeAllCostsInvoices(['wkład osobowy'], false))
					},
					new: {
						donation: this.formatMoney(this.costOfTypeAllCostsInvoices(['z dotacji'], true)),
						otherSources: this.formatMoney(this.costOfTypeAllCostsInvoices([
							'środki finansowe własne',
							'świadczenie pieniężne od odbiorców',
							'środki finansowe z innych źródeł publicznych',
							'pozostałe'], true)),
						interests: this.formatMoney(this.costOfTypeAllCostsInvoices(['odsetki', 'przychody'], true)),
						ownInKind: this.formatMoney(this.costOfTypeAllCostsInvoices(['wkład rzeczowy'], true)),
						ownHuman: this.formatMoney(this.costOfTypeAllCostsInvoices(['wkład osobowy'], true))
					}
				};
			},

			getInvoiceComparisonResult (prev, curr) {
				return (prev.documentDate !== curr.documentDate ||
					prev.documentName !== curr.documentName ||
					prev.documentNumber !== curr.documentNumber ||
					prev.totalValue !== curr.totalValue ||
					prev.paymentDates[0] !== curr.paymentDates[0] ||
					prev.actions.length !== curr.actions.length ||
					prev.administrative.length !== curr.administrative.length ||
					this.actionsChanged(prev.actions, curr.actions) ||
					this.administrativeChanged(prev.administrative, curr.administrative)) ?
					InvoiceComparisonResult.changed : InvoiceComparisonResult.same;
			},

			invoiceActionsDataChanged (prev, curr) {
				return prev.documentDate !== curr.documentDate ||
					prev.documentName !== curr.documentName ||
					prev.documentNumber !== curr.documentNumber ||
					prev.totalValue !== curr.totalValue ||
					prev.paymentDates[0] !== curr.paymentDates[0] ||
					prev.actions.length !== curr.actions.length ||
					this.actionsChanged(prev.actions, curr.actions);
			},

			invoiceAdministrativeDataChanged (prev, curr) {
				return prev.documentDate !== curr.documentDate ||
					prev.documentName !== curr.documentName ||
					prev.documentNumber !== curr.documentNumber ||
					prev.totalValue !== curr.totalValue ||
					prev.paymentDates[0] !== curr.paymentDates[0] ||
					prev.administrative.length !== curr.administrative.length ||
					this.administrativeChanged(prev.administrative, curr.administrative);
			},

			actionsChanged (prev, curr) {
				for (let i = 0; i < prev.length; i++) {
					if (prev[i].costs.length !== curr[i].costs.length || prev[i].name !== curr[i].name) return true;
					for (let idx = 0; idx < prev[i].costs.length; idx++) {
						if (prev[i].costs[idx].description !== curr[i].costs[idx].description ||
							prev[i].costs[idx].name !== curr[i].costs[idx].name ||
							prev[i].costs[idx].costDivisions.length !== curr[i].costs[idx].costDivisions.length ||
							this.costDivisionsChanged(prev[i].costs[idx].costDivisions, curr[i].costs[idx].costDivisions)) return true;
					}
				}
				return false;
			},

			costDivisionsChanged (prevDivision, currDivisions) {
				for (let idx = 0; idx < prevDivision.length; idx++) {
					if (prevDivision[idx].totalPrice !== currDivisions[idx].totalPrice ||
						prevDivision[idx].type !== currDivisions[idx].type) return true;
				}
				return false;
			},

			administrativeChanged (prev, curr) {
				for (let idx = 0; idx < prev.length; idx++) {
					if (prev[idx].description !== curr[idx].description ||
						prev[idx].name !== curr[idx].name ||
						prev[idx].costDivisions.length !== curr[idx].costDivisions.length ||
						this.costDivisionsChanged(prev[idx].costDivisions, curr[idx].costDivisions)) return true;
				}
				return false;
			},

			costOfTypeAllCostsInvoices (costTypes, newData) {
				return this.costOfTypeActionsCostsInvoices(costTypes, newData) + this.costOfTypeAdministrativeCostsInvoices(costTypes, newData);
			},

			costOfTypeActionsCostsInvoices (costTypes, newData) {
				let invoices = this.actionsCostsInvoices.filter(invoice => newData ? invoice.type !== InvoiceComparisonResult.removed : invoice.type !== InvoiceComparisonResult.added);
				invoices = invoices.map(invoice => invoice.type === InvoiceComparisonResult.changed ? (newData ? invoice.data.new : invoice.data.old) : invoice.data);
				let result = 0;
				for (let invoice of invoices) {
					result += this.costOfTypeAction(costTypes, invoice.actions);
				}
				return result;
			},

			costOfTypeAdministrativeCostsInvoices (costTypes, newData) {
				let invoices = this.administrativeCostsInvoices.filter(invoice => newData ? invoice.type !== InvoiceComparisonResult.removed : invoice.type !== InvoiceComparisonResult.added);
				invoices = invoices.map(invoice => invoice.type === InvoiceComparisonResult.changed ? (newData ? invoice.data.new : invoice.data.old) : invoice.data);
				let result = 0;
				for (let invoice of invoices) {
					result += this.costOfType(costTypes, invoice.administrative);
				}
				return result;
			},

			costOfTypeAction (types, actions) {
				let result = 0;
				for (const action of actions) {
					result += this.costOfType(types, action.costs);
				}
				return result;
			},

			costOfType (types, costs) {
				let result = 0;
				for (const cost of costs) {
					for (const division of cost.costDivisions) {
						if (types.indexOf(division.type) !== -1) {
							result += division.totalPrice;
						}
					}
				}
				return result;
			}
		},

		props: {
			oldInvoices: {required: true},
			currentInvoices: {required: true}
		}
	};
</script>

<style scoped>

</style>